/**
 * Session Market number fields: type digits or use native spinner arrows only.
 * Mouse-wheel and ArrowUp/ArrowDown must not nudge values (Lab / operator UX).
 *
 * Important: do **not** blur on wheel — ScoreDashboard Order / Bet Delay / Min Bet
 * save on blur, so blur-after-wheel would persist the nudges we are blocking.
 */

export function blockNumberInputWheel(
  event: {
    preventDefault(): void
    currentTarget: { type?: string }
  },
  inputType?: string,
): boolean {
  const type = inputType ?? event.currentTarget.type
  if (type !== 'number') return false
  event.preventDefault()
  return true
}

/** Blocks ArrowUp / ArrowDown stepping on type=number (spinners + typing stay). */
export function blockNumberInputKeyStep(
  event: { key: string; preventDefault(): void },
  inputType: string | undefined,
): boolean {
  if (inputType !== 'number') return false
  if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown') return false
  event.preventDefault()
  return true
}

/**
 * React's synthetic `onWheel` is often passive — `preventDefault` is ignored and
 * the value still steps. Attach a non-passive listener so Order / Bet Delay /
 * Min Bet / Max Limit To Suspend never change on page scroll.
 */
export function attachNumberInputWheelBlock(el: HTMLInputElement | null): () => void {
  if (!el) return () => {}
  const onWheel = (event: WheelEvent) => {
    if (el.type !== 'number') return
    event.preventDefault()
  }
  el.addEventListener('wheel', onWheel, { passive: false })
  return () => el.removeEventListener('wheel', onWheel)
}
